export default "__VITE_ASSET__71c8e973__"